export enum AlarmEventSource {
    Unknown = 0,

    Client = 1000,

    MindviewClient = 1100,

    AnalysisService = 1210,
    MonitoringService = 1220,
    HeartbeatService = 1230,

    Scheduling = 1300,
    WebJobScheduling = 1301,

    AlarmCentral = 2000,
    PreAlarmCentral = 2100,
    MainAlarmCentral = 2200,
    CustomerAlarmCentral = 2900,

    WebPortal = 3000,
    AdminPortal = 3010,
    CustomerPortal = 3020,
    MindCarePortal = 3030,

    BackendProcessing = 4000,
    WebJobProcessing = 4100,
}
